var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h1",
      [
        _vm._v(
          " " +
            _vm._s(_vm.$t("invoice.details.invoiceNumber")) +
            ": " +
            _vm._s(_vm.invoice.number) +
            " "
        ),
        _vm.invoice.left_to_pay === 0
          ? _c(
              "v-chip",
              {
                staticStyle: {
                  color: "#44d3af",
                  "background-color": "rgba(30,255,200,0.22) !important"
                },
                attrs: { label: "", outlined: "" }
              },
              [_vm._v(_vm._s(_vm.$t("invoice.paid")) + " ")]
            )
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12  lighten-4" },
      [
        _vm.loading
          ? _c(
              "v-row",
              { staticClass: "pa-4 white" },
              [
                _c("v-col", [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("global.loading")))])
                ])
              ],
              1
            )
          : _vm._e(),
        !_vm.loading
          ? _c(
              "v-row",
              { staticClass: "pa-4 white" },
              [
                _c(
                  "v-col",
                  [
                    _c(
                      "v-row",
                      { attrs: { "align-content": "space-between" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  value:
                                    _vm.invoice.net_in_currency +
                                    " " +
                                    _vm.invoice.currency_symbol,
                                  label: _vm.$t("invoice.details.netAmount"),
                                  readonly: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "prepend" },
                                    slot: "prepend"
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticStyle: { "font-weight": "normal" }
                                      },
                                      [_vm._v("fa-money-bill-alt")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  value:
                                    _vm.invoice.gross_in_currency +
                                    " " +
                                    _vm.invoice.currency_symbol,
                                  label: _vm.$t("invoice.details.grossAmount"),
                                  readonly: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { slot: "prepend" },
                                    slot: "prepend"
                                  },
                                  [_c("v-icon", [_vm._v("fa-money-bill-alt")])],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "invoice.dataTableHeaders.issueDate"
                                  ),
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.invoice.issue_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.invoice, "issue_date", $$v)
                                  },
                                  expression: "invoice.issue_date"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { slot: "prepend" },
                                    slot: "prepend"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("fa-file-invoice-dollar")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "invoice.dataTableHeaders.sellDate"
                                  ),
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.invoice.sale_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.invoice, "sale_date", $$v)
                                  },
                                  expression: "invoice.sale_date"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { slot: "prepend" },
                                    slot: "prepend"
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticStyle: { "font-weight": "normal" }
                                      },
                                      [_vm._v("fa-calendar-alt")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _vm.invoice.left_to_pay !== 0
                              ? _c(
                                  "v-text-field",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "invoice.dataTableHeaders.leftToPay"
                                      ),
                                      readonly: ""
                                    },
                                    model: {
                                      value: _vm.invoice.left_to_pay,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.invoice,
                                          "left_to_pay",
                                          $$v
                                        )
                                      },
                                      expression: "invoice.left_to_pay"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2",
                                        attrs: { slot: "prepend" },
                                        slot: "prepend"
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-weight": "normal",
                                              color: "orange"
                                            }
                                          },
                                          [_vm._v("warning")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "3" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "accent",
                                  disabled: _vm.$store.getters["Ajax/loading"],
                                  block: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadInvoice(_vm.invoice)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("invoice.download")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("h2", [_vm._v(_vm._s(_vm.$t("invoice.details.items")))]),
                    _vm._l(_vm.invoice.invoiceItems, function(invoiceItem) {
                      return _c("div", { key: invoiceItem.serial_index }, [
                        _c(
                          "fieldset",
                          { staticClass: "pd-1 custom-fieldset" },
                          [
                            _c("legend", { staticClass: "primary--text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("invoice.entry")) +
                                  " " +
                                  _vm._s(invoiceItem.serial_index)
                              )
                            ]),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "text-center align-content-center fill-height align-content-center",
                                    attrs: { cols: "1", md: "1" }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticStyle: {
                                          "font-size": "46px",
                                          color: "rgba(0, 0, 0, 0.32)"
                                        }
                                      },
                                      [_vm._v("info")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "11", md: "3" } },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          staticClass: "no-line-after-input",
                                          attrs: {
                                            label: _vm.$t(
                                              "invoice.dataTableHeaders.gross"
                                            ),
                                            disabled: "",
                                            value:
                                              invoiceItem.gross_in_currency +
                                              " " +
                                              _vm.invoice.currency_symbol
                                          }
                                        }),
                                        _c("v-text-field", {
                                          staticClass: "no-line-after-input",
                                          attrs: {
                                            label: _vm.$t(
                                              "invoice.dataTableHeaders.net"
                                            ),
                                            disabled: "",
                                            value:
                                              invoiceItem.net_price_in_currency +
                                              " " +
                                              _vm.invoice.currency_symbol
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "11", md: "7" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "no-line-after-input",
                                      attrs: {
                                        label: _vm.$t("global.itemName"),
                                        disabled: "",
                                        value: invoiceItem.name
                                      }
                                    })
                                  ],
                                  1
                                ),
                                invoiceItem.xtur_booking_id != null
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "6", md: "1" } },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              disabled: "",
                                                              icon: ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "fa-suitcase"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "booking.bookingDetails"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("invoice.details.payments")))
                    ]),
                    _vm.invoice.payments.length === 0
                      ? _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("invoice.details.noPaymentsYet")) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _vm._l(_vm.invoice.payments, function(payment) {
                      return _c("div", { key: payment.id }, [
                        _c(
                          "fieldset",
                          { staticClass: "pd-1 custom-fieldset" },
                          [
                            _c("legend", { staticClass: "primary--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "$staticData.paymentTranslations." +
                                      payment.payment_type.replace(
                                        /[."\s]/g,
                                        ""
                                      )
                                  )
                                )
                              )
                            ]),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "text-center align-content-center fill-height align-content-center",
                                    attrs: { cols: "1", md: "1" }
                                  },
                                  [
                                    payment.payment_type.match(/przelew/i) ||
                                    payment.payment_type.match(/kompensata/i)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "46px",
                                              color: "rgba(0, 0, 0, 0.32)"
                                            }
                                          },
                                          [_vm._v("fa-university ")]
                                        )
                                      : _vm._e(),
                                    payment.payment_type.match(/gotówka/i)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "46px",
                                              color: "rgba(0, 0, 0, 0.32)"
                                            }
                                          },
                                          [_vm._v("fa-money-bill-alt ")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "5", md: "2" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "no-line-after-input",
                                      attrs: {
                                        label: _vm.$t("global.amount"),
                                        disabled: "",
                                        value:
                                          payment.amount_in_payment_currency +
                                          " " +
                                          payment.payment_currency
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6", md: "3" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "no-line-after-input",
                                      attrs: {
                                        label: _vm.$t(
                                          "invoice.details.paymentDate"
                                        ),
                                        disabled: "",
                                        value: payment.date
                                      }
                                    })
                                  ],
                                  1
                                ),
                                payment.payment_currency !==
                                _vm.invoice.currency_symbol
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "6", md: "3" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "no-line-after-input",
                                          attrs: {
                                            label: _vm.$t(
                                              "invoice.details.amountInDocumentCurrency"
                                            ),
                                            disabled: "",
                                            value:
                                              payment.amount_in_document_currency +
                                              " " +
                                              _vm.invoice.currency_symbol
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                payment.payment_currency !==
                                _vm.invoice.currency_symbol
                                  ? _c(
                                      "v-col",
                                      { attrs: { cols: "6", md: "3" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "no-line-after-input",
                                          attrs: {
                                            label: _vm.$t("exchangeRate"),
                                            disabled: "",
                                            value:
                                              payment.exchange_rate +
                                              " (" +
                                              payment.exchange_rate_date +
                                              ")"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }